import { Button, Typography } from '@mui/material';
import { BaseDialog } from '@/components/shared/base-dialog';
import { Icon } from '@/components/shared/icon';

interface ConfirmReplaceFeedbackDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const ConfirmReplaceFeedbackDialog = ({
  open,
  onClose,
  onConfirm,
}: ConfirmReplaceFeedbackDialogProps) => {
  return (
    <BaseDialog
      open={open}
      onClose={onClose}
      title="Um novo feedback substituirá o que está salvo na plataforma."
      icon={<Icon name="feedbacks-change" size={48} />}
      actionsComponent={
        <>
          <Button onClick={onClose}>Não</Button>
          <Button variant="contained" onClick={onConfirm}>
            Sim
          </Button>
        </>
      }
    >
      <Typography>
        Ao continuar, o seu antigo feedback não ficará mais disponível na
        plataforma, iremos utilizar o novo para recalcular as habilidades. Tem
        certeza que deseja continuar?
      </Typography>
    </BaseDialog>
  );
};
